import { render, staticRenderFns } from "./dialogAgent.vue?vue&type=template&id=6446a5c5&scoped=true&lang=pug&"
import script from "./dialogAgent.vue?vue&type=script&lang=js&"
export * from "./dialogAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6446a5c5",
  null
  
)

export default component.exports